import { GoCircle } from 'react-icons/go';
import { styled } from 'styled-components';

const Circle = styled(GoCircle)`
  margin: 0 0 0 10px;
  color: ${(props) => {
    switch (props.color) {
      case 'active':
        return props.theme.COLOR_STATUS_GREEN;
      case 'new':
        return props.theme.COLOR_STATUS_BLUE;
      case 'suspended':
        return props.theme.COLOR_STATUS_ORANGE;
      default:
        return props.theme.COLOR_STATUS_DEFAULT;
    }
  }};
`;

const StyledCircleIndicator = {
  Circle,
};

export default StyledCircleIndicator;
